import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CollectionParams} from '../../../../types/types';

const params: CollectionParams = {};

const initialState = params

const operationHistory = createSlice({
  name: 'operation-history-params',
  initialState,
  reducers: {
    setOperationHistoryParams: (state,action:PayloadAction<CollectionParams>) => {

      return (state = action.payload)
      
    },
  },
 
});

// Reducer
export default operationHistory.reducer;

// Actions
export const {setOperationHistoryParams} = operationHistory.actions;